interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete?: () => void;
  onConfirm?: () => void;
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  loading?: boolean;
}

export const CustomModal = ({
  isOpen,
  onClose,
  onDelete,
  onConfirm,
  title = "Are you sure?",
  message = "Do you want to delete this item?",
  confirmText = "Delete",
  cancelText = "Cancel",
  loading = false,
}: ModalProps) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    } else if (onDelete) {
      onDelete();
    }
  };

  return (
    <div className="fixed inset-0 bg-gray-200 bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-100">
        <h2 className="text-xl font-semibold text-center mb-2">
          {title}
        </h2>
        <p className="text-center mb-4 text-gray-600">{message}</p>
        <div className="flex items-center justify-center gap-6">
          <button
            onClick={onClose}
            disabled={loading}
            className="px-4 py-2 text-black rounded border hover:bg-gray-200 disabled:opacity-50"
          >
            {cancelText}
          </button>
          <button
            onClick={handleConfirm}
            disabled={loading}
            className="bg-teal-500 text-white px-6 py-2 rounded hover:bg-teal-600 flex items-center gap-2 disabled:opacity-50"
          >
            {loading ? "Processing..." : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

